<template>
    <span
            :class="{
                'loading-placeholder': true,
                'badge': true
            }"
    >&nbsp;</span>
</template>
<script>
    export default {
        name: 'BadgeLoadingPlaceholder'
    }
</script>
